import type { Annotations } from './types';

export const ANNOTATIONS: Annotations = [];
